module.exports = __webpack_public_path__ + "web/img/verify5.82ece932.png";